@use "@fukuri-admins/ui/layout" as *;

$Primary: #21e4a3;

.screen {
  @include screen;
}

.content {
  @include content;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 100%;
  color: text('White');
  background-color: $Primary;
}

